import { OtError } from '@openticket/lib-log';

export interface ShopWidgetExampleErrorData {
    message: string;
    slug: string;
    shop_id?: string;
}

export class ShopWidgetExampleError extends OtError {

    constructor(data: ShopWidgetExampleErrorData) {
        super('ShopWidgetExampleError', data.slug, data.message);

        this.captureStackTrace(ShopWidgetExampleError);
        this.additionalData(data);
    }

    private additionalData(data: ShopWidgetExampleErrorData): void {
        if (data.shop_id) {
            this.addContext('shop_id', data.shop_id);
        }
    }

}
